import { render, staticRenderFns } from "./NotificationsBell.vue?vue&type=template&id=a3010246&scoped=true&"
import script from "./NotificationsBell.vue?vue&type=script&lang=js&"
export * from "./NotificationsBell.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsBell.vue?vue&type=style&index=0&id=a3010246&prod&lang=css&"
import style1 from "./NotificationsBell.vue?vue&type=style&index=1&id=a3010246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3010246",
  null
  
)

export default component.exports